   
<template>
    <div>
        <a-card title="告警统计" >
         <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-form layout="inline" @submit="handleSubmit" :form="form">
               
            <a-form-model-item  label="请选择日期" prop="searchTimeRange">
            <a-popover v-model="rangevisible" trigger="click" placement="bottom" class="search_range">
                        <template slot="title">
                            <a-input v-model="searchTimeRange" placeholder="" class="date_input date_content" />
                        </template>
                        <template slot="content">
                            <div class="date_content">
                                <a-button type="link" @click="handleTime(1)">今天</a-button>
                                <a-button type="link" @click="handleTime(2)">昨天</a-button>
                                <a-button type="link" @click="handleTime(3)">本周</a-button>
                                <a-button type="link" @click="handleTime(4)">上周</a-button>
                                <a-button type="link" @click="handleTime(5)">本月</a-button>
                                <a-button type="link" @click="handleTime(6)">上月</a-button>
                                <a-button type="link" @click="handleTime(100)">自定义</a-button>

                            </div>
                        </template>
                        <a-button type="normal" style="color:#0070cc" :title="searchTimeRange">
                            {{dateTypeTitle}}
                            <a-icon type="down" style="color: #0070cc" />
                        </a-button>
                    </a-popover>
            </a-form-model-item>
             <a-input v-model="timenumber"  v-show="false" />
             <a-form-item label="应用编码">
              <a-input  v-model="searchP.appcode"  placeholder="请输入应用编码"  @click="handleSelecter" ></a-input>
            </a-form-item>

            <AppSelecter :modalState="modalState" @onModalHide="onAppselecterHide"></AppSelecter>
            <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
            </a-form-item>

            <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
            </a-button>
          </a-form-item>
        </a-form>

        <a-tabs type="card"  default-active-key="errorcode" @change="callback" style="top:10px;">
         
            <a-tab-pane key="errorcode" tab="异常码"> 
                  <div  id="chartname1" style="padding-right:20px;border:1px solid gray"> </div> 
                  <div  id="chartname_1" style="top:20px;border:1px solid gray"> </div> 
           </a-tab-pane>

            <a-tab-pane key="failrate" tab="失败率" force-render>
                <a-tabs type="card" default-active-key="failnumber" @change="callbackType">
                    <a-tab-pane key="failnumber" tab="按异常数">  </a-tab-pane>
                    <a-tab-pane key="failrate" tab="按失败率">  </a-tab-pane>
                </a-tabs>
              
               <div  id="chartname2" style="padding-right:20px;border:1px solid gray;top:10px;"> </div>

               <a-table :columns="columns" :data-source="data_failrate"  :pagination="false" :loading="tLoading" rowKey="id"  style="top:30px;">
                        <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                                <span> 
                                        <router-link  :to="{ path:'serviceurldetails', query: { appcode: record.appcode,serviceurl: record.serviceurl,timenumber:timenumber,searchTimeRange:searchTimeRange}}"
                                        >查看
                                        </router-link>
                                </span>
                            </div>
                        </template>
               </a-table>
            </a-tab-pane>

            <a-tab-pane key="timeout" tab="超时">
                <a-tabs type="card" default-active-key="failnumber" @change="callbackType">
                      <a-tab-pane key="failnumber" tab="按异常数">  </a-tab-pane>
                      <a-tab-pane key="failrate" tab="按失败率">  </a-tab-pane>
                </a-tabs>
              
                <div  id="chartname3" style="padding-right:20px;border:1px solid red；top:10px;"> </div>
           
                <a-table :columns="columns" :data-source="data_timeout"  :pagination="false" :loading="tLoading" rowKey="id" style="top:30px;" >
                        <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                                <span> 
                                <router-link  :to="{ path:'serviceurldetails', query: { appcode: record.appcode,serviceurl: record.serviceurl,timenumber:timenumber,searchTimeRange:searchTimeRange}}"
                                        >查看
                                        </router-link>
                                </span>
                            </div>
                        </template>
                </a-table>

            </a-tab-pane>

            <!-- <a-tab-pane key="indexhtml" tab="总概览">
              <div  id="chartname4" style="padding-right:20px;border:1px solid red；top:10px;"> </div>
            </a-tab-pane> -->

        </a-tabs>
        
       </a-card>
    </div>
          
</template>

<script>
import { mapState } from "vuex";
import AppSelecter from '@/components/AppSelecter'
const columns = [
    {
        title: "序号",
        width: 40,
        align: "center",
        customRender: (text, record, index) => {
            return  index+1;
        }
    },
    {
        title: "服务地址",
        dataIndex: "serviceurl",
        width:100
    },
    {
        title: "应用编码",
        dataIndex: "appcode",
        width:60
    },
    {
        title: "告警类型",
        dataIndex: "alerttypename",
        width:80
    },
    {
        title: "异常次数",
        dataIndex: "failnumber",
        width:80
    },
    {
        title: "失败率(%)",
        dataIndex: "failrate",
        width:80
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }
    
];
const data_failrate = [];
const data_timeout = [];
   
export default {
    components: {
        AppSelecter
    },
    data() {
        return {
            form: this.$form.createForm(this),
            logstorename:'',
            projectname:'',
            dateTypeTitle:'今天',
            rangevisible:false,
            searchTimeRange:'',
            timenumber:'',
            syslist:[],
            total:0,
            pageSize:5,
            page:undefined,
            errorcodeChart:null,
            errorcodeDetailChart:null,
            failrateChart:null,
            timeoutChart:null,
            sumData:[],
            errorDataList:[],
            errorDataDetailList:[],
            failerateDataList:[],
            timeoutDataList:[],
            chartDetail:null,
            columns,
            data_failrate,
            data_timeout,
            tLoading:false,
            chartSys:null,
            chartSys_1:null,
            key1:'errorcode',
            key2:'failnumber',
            modalState: {//选择app弹框
                isShow: false,
                rowsType: 'radio' // or 'checkbox'，单选或多选
            },
        }
    },
    methods: {

        handleTime(t){
            let cRange = {};
            this.timenumber=t;
            if(t != 100){
                cRange = this.G.getRecentDate(t)
                this.dateTypeTitle = cRange.title;
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.searchP.starttime=cRange.start_time;
                this.searchP.endtime=cRange.end_time;
                this.searchP.dateTypeTitle = cRange.title;
                this.searchP.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.hide();

            }
            else{
                cRange = this.G.getRecentDate(7)
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.searchP.starttime=cRange.start_time;
                this.searchP.endtime=cRange.end_time;
                this.dateTypeTitle = "自定义"
            }
        },

        handleTimeJump(t,searchTime){
            let cRange = {};
            if(t != 100){
                cRange = this.G.getRecentDate(t)
                this.dateTypeTitle = cRange.title;
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.timenumber =t;
                this.hide();

            }
            else{
                this.searchTimeRange =searchTime;
                this.timenumber =t;
                this.dateTypeTitle = "自定义"
            }
        },

        handleSelecter() {
            this.modalState.isShow = true;
        },
        onAppselecterHide(result) {
            console.log(result)
            if (result == undefined) {
                this.modalState.isShow = false;
                return;
            }
            if (result.length > 0) {
                this.searchP.appcode = result[0].appcode
            }
            this.modalState.isShow = false;
        },

        hide() {
            this.rangevisible = false;
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "alarmmanager/getEmptySearch",
                showMsg: true
            })

            this.appcode='';
            this.handleTime(1);
        },

        handleSubmit(e){
            e.preventDefault();
            this.callback(this.key1);
        },

        handleSearch(){
            this.callback(this.key1);
        },
        
        
        //上级按钮
        callback(key1) {
            console.log("callback===>"+key1);
            this.key1=key1;
            this.key2='failnumber';
            this.drawLine(key1,this.key2);
        },
        
        //下级按钮
        callbackType(key2) {
            console.log("callbackType===>"+key2);
            this.key2=key2;
            this.drawLine(this.key1,key2);
        },

        drawLine(key,keyType) {
            console.log("drawLine===>"+key+"_____________"+keyType);
            let urlreq='';
            let that = this;
            let c_params = {};
            if(keyType=='' ){
                keyType='failnumber'
            }
            if(key=='errorcode'||key==''){// 异常码
                urlreq="alarmmanager/queryAnalysisByError";
                c_params = {
                    urlparams:false,
                    ...this.searchP
                }
 
            }else if(key=='failrate'){// 失败率
                urlreq="alarmmanager/queryFailAndTimeout";
                c_params = {
                    errorType:'2',
                    keyType:keyType,
                    urlparams:false,
                    ...this.searchP
                }
                

            }else if(key=='timeout'){ // 超时
                urlreq="alarmmanager/queryFailAndTimeout";
                c_params = {
                    errorType:'3',
                    keyType:keyType,
                    urlparams:false,
                    ...this.searchP
                }

            }else if(key=='indexhtml'){ // 总概览
                urlreq="alarmmanager/queryTotalAnalysisdataList";
            }

            let timeRange = that.searchTimeRange.split('~');
            c_params.starttime = (new Date(timeRange[0]).getTime());
            c_params.endtime = (new Date(timeRange[1]).getTime());

            that.$store.dispatch({
                type: urlreq,
                params:c_params
            }).then((res)=>{
                if(res.status == 200){
                    if(key=='errorcode'||key==''){// 异常码

                        that.errorDataList = res.data.data.data;
                        document.getElementById("chartname1").style.height = "500px";
                        that.errorcodeChart = that.$echarts.init(document.getElementById("chartname1"));
                        let option = that.getErrorcodeOption();
                        that.errorcodeChart.setOption(option);

                        that.chartSys = this.$echarts.init(document.getElementById("chartname1"));
                        // 窗口大小自适应方案
                        that.chartSys.setOption(option);
                        that.chartSys.off('click');
                        that.chartSys.on('click', function (params) {
                            if (params.componentType === 'series') {
                                if (params.seriesType === 'pie' && params.name) {
                                    console.log("clicked  " + params.name )
                                    that.getLogDataPerErrorcode_(params.name);
                                }
                            }
                        });
                    
                    }else if(key=='failrate'){// 失败率

                        that.failerateDataList = res.data.data;
                        document.getElementById("chartname2").style.height = "500px";
                        that.failrateChart = that.$echarts.init(document.getElementById("chartname2"));
                        let optionA = that.getFailerateOption(this.failerateDataList);
                        that.failrateChart.setOption(optionA);
                        this.data_failrate=  res.data.data.detailList;   

                        // that.chartSys = this.$echarts.init(document.getElementById("chartname2"));
                        // // 窗口大小自适应方案
                        // that.chartSys.setOption(optionA);
                        that.failrateChart.off('click');
                        that.failrateChart.on('click', function (params) {
                            console.log("clicked  " + params.name )
                            that.getLogDataPerAppcode_(params.name);
                        });
                    }else if(key=='timeout'){ // 超时

                        that.timeoutDataList = res.data.data;
                        document.getElementById("chartname3").style.height = "500px";
                        that.timeoutChart = that.$echarts.init(document.getElementById("chartname3"));
                        let optionB = that.getTimeoutOption(this.timeoutDataList);
                        that.timeoutChart.setOption(optionB);
                        this.data_timeout=  res.data.data.detailList;   
                        that.failrateChart.off('click');
                        that.timeoutChart.on('click', function (params) {
                            // if (params.componentType === 'series') {
                            // if (params.seriesType === 'pie' && params.name) {
                            console.log("clicked  " + params.name )
                            that.getLogDataPerAppcode_(params.name);
                        // }
                        // }
                        });
                    }else if(key=='indexhtml'){ // 总概览
                     
                    }
            
                }
            });

        },

        // 异常吗饼形图
        getErrorcodeOption(){

            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        let res = '<div class="tooltipbox"><h2 style="color:white">' + params.data.name + '</h2> <p>异常数：'+ params.data.value +'</p><p>占比：'+ params.percent +'%</p></div>';
                        return res;
                    },
                },
                legend: {
                    show:true,
                    type: 'scroll',
                    orient: 'vertical',
                    left: '75%',
                    top: 20,
                    bottom: 20,
                },
                series: [
                    {
                        name: '异常数',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // right:'100px',
                        top:'50px',
                        left:'30px',
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '20',
                                fontWeight: 'bold',
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: this.errorDataList
                    }
                ]
            };

            return option
        },
        
        // 异常码饼图点击事件
        getLogDataPerErrorcode_(exceptioncode){
            console.log(exceptioncode)

            let that = this;
            
            let c_params = {
                exceptioncode:exceptioncode,
                appcode:this.searchP.appcode,
                urlparams:false,
                ...this.searchP
            }

            let timeRange = that.searchTimeRange.split('~');
            c_params.starttime = (new Date(timeRange[0]).getTime());
            c_params.endtime = (new Date(timeRange[1]).getTime());

            that.$store.dispatch({
                type: 'alarmmanager/queryAnalysisdetailList',
                params:c_params
            }).then((res)=>{
                if(res.status == 200){
                    that.errorDataDetailList = res.data.data;
                    document.getElementById("chartname_1").style.height = "500px";
                    this.errorcodeDetailChart = this.$echarts.init(document.getElementById("chartname_1"));
                    let option = this.getErrorcodeDetailOption(that.errorDataDetailList);
                    this.errorcodeDetailChart.setOption(option);
                }
            });
        },

        // 异常码饼图点击事件
        getLogDataPerAppcode_(appcode){
            console.log(appcode)
            let timenumber=this.timenumber;
            let searchTimeRange=this.searchTimeRange;
            this.$router.push({
                path: "serviceurldetails",
                query:{
                    appcode,
                    timenumber,
                    searchTimeRange
                }
            });
        },

        // 异常码详情 饼图
        getErrorcodeDetailOption(errorDataDetailList){
            let option = {
                title: {
                    text: errorDataDetailList.title,
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: '50%',
                        data:errorDataDetailList.data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            return option
        },
        
        // 失败率柱状图
        getFailerateOption(aDataList){
            // 绘制图表配置
            let option = {};
            if(this.key2=='failrate'){
                option ={ 
                    xAxis: {
                        type: 'category',
                        data: aDataList.xAxis_appcode,
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#9c9c9c',
                            },
                        },
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            show: true,
                            interval: 0,
                            formatter: function (value) {   //关键代码
                                var res = value
                                if (res.length > 7) {
                                    res = res.substring(0, 6) + '..'
                                }
                                return res
                            },
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#blue'
                            }
                        },
                        axisLabel: {
                            formatter: '{value} %',
                            color:''
                        }

                    },
                    tooltip: {
                        show:true,
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    series: 
                    [
                        {
                            name: '失败率%',
                            type: 'bar',
                            barWidth: '70%',
                            data: aDataList.yAxis_ratio,
                            itemStyle:{
                                normal:{
                                    color: 'SteelBlue'
                                }
                            },
                        }
                            
                    ]
                };
            }else{
                option ={ 
                    xAxis: {
                        type: 'category',
                        data: aDataList.xAxis_appcode,
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#9c9c9c',
                            },
                        },
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            show: true,
                            interval: 0,
                            formatter: function (value) {   //关键代码
                                var res = value
                                if (res.length > 7) {
                                    res = res.substring(0, 6) + '..'
                                }
                                return res
                            },
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#blue'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}'+'个',
                            color:''
                        }

                    },
                    tooltip: {
                        show:true,
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    series: 
                    [
                        {
                            name: '异常数',
                            type: 'bar',
                            barWidth: '70%',
                            data: aDataList.yAxis_failnumber,
                            itemStyle:{
                                normal:{
                                    color: 'SteelBlue'
                                }
                            },
                        }
                            
                    ]
                };
            }
           
            return option
        },

        //  超时 柱状图
        getTimeoutOption(aDataList){  // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {};
            if(this.key2=='failrate'){
                option ={ 
                    xAxis: {
                        type: 'category',
                        data: aDataList.xAxis_appcode,
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#9c9c9c',
                            },
                        },
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            show: true,
                            interval: 0,
                            formatter: function (value) {   //关键代码
                                var res = value
                                if (res.length > 7) {
                                    res = res.substring(0, 6) + '..'
                                }
                                return res
                            },
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#blue'
                            }
                        },
                        axisLabel: {
                            formatter: '{value} %',
                            color:''
                        }

                    },
                    tooltip: {
                        show:true,
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    series: 
                    [
                        {
                            name: '失败率(%)',
                            type: 'bar',
                            barWidth: '70%',
                            data: aDataList.yAxis_ratio,
                            itemStyle:{
                                normal:{
                                    color: 'SteelBlue'
                                }
                            },
                        }
                            
                    ]
                };
            }else{
                option ={ 
                    xAxis: {
                        type: 'category',
                        data: aDataList.xAxis_appcode,
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#9c9c9c',
                            },
                        },
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            show: true,
                            interval: 0,
                            formatter: function (value) {   //关键代码
                                var res = value
                                if (res.length > 7) {
                                    res = res.substring(0, 6) + '..'
                                }
                                return res
                            },
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#blue'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}'+'个',
                            color:''
                        }

                    },
                    tooltip: {
                        show:true,
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    series: 
                    [
                        {
                            name: '异常数',
                            type: 'bar',
                            barWidth: '70%',
                            data: aDataList.yAxis_failnumber,
                            itemStyle:{
                                normal:{
                                    color: 'SteelBlue'
                                }
                            },
                        }
                            
                    ]
                };
            }
           
            return option
        },

        getAllSys(){
            let that = this;
         
            that.$store.dispatch({
                type: "servicekey/getAppList",
                params:{
                    urlparams:false
                }
            }).then((res)=>{
                if(res.status == 200){
                    that.syslist = res.data.data.list;
                }
            }).catch(() => {
            });
        },
    },
    props:["chartname"],

    computed:{
        ...mapState('alarmmanager', {
            searchP: state => state.searchP,
        })

        
    },

    mounted() {
        const {query} = this.$route;
        let timenumber =query.timenumber;
        this.handleTimeJump(timenumber,query.searchTimeRange)
        this.searchP.appcode=query.appcode+'-001'
        this.drawLine(this.key1,this.key2)

    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);
    }
}

</script>
<style lang="less" scoped>
    .titleBox{
        width:100%;
        height: auto;
        padding:0 0 10px 0;
    }
    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
        margin-bottom: 20px;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #6d6d6d;
        font-weight: bolder;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
    cursor: default;

    }
    .dashIcon{
        color: #1890ff;
        font-size: 20px;
        margin-left: 12px;
        line-height: 38px;
        cursor: pointer;
    }
    .search_range{
        margin-left: 10px;
    }
    .pieBox{
        width:100%;
        position:relative;
    }

    #syspieDiv{
        width:360px;
        margin-left: 80px;
    }
    </style>